/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FuelReceiptFuelType = {
    fuel_type?: FuelReceiptFuelType.fuel_type | null;
};
export namespace FuelReceiptFuelType {
    export enum fuel_type {
        PETROL = 'petrol',
        DIESEL = 'diesel',
        HVO = 'hvo',
        E85 = 'e85',
        LPG = 'lpg',
        CNG = 'cng',
        ELECTRICITY = 'electricity',
        HYDROGEN = 'hydrogen',
        ADBLUE = 'adblue',
    }
}

